import { catchCalculatorError } from "@component/assets/AbstractListingCalculator/domain";
import type { CommonOptions } from "bm-ui-kit";
import { http } from "bm-ui-kit";
import type { MutualFundRequest, MutualFundResponseItem, MutualFundSearchParams, MutualFundSort } from "./types";
import { Config } from "@config";

let MANAGER_IDS;
export async function getManagerIds(): Promise<CommonOptions> {
	if (!MANAGER_IDS) {
		return http.get(Config.getApiUrl("/api/public/mutual-fund/api/v2/managers")).then((response: CommonOptions) => {
			MANAGER_IDS = response;

			return response;
		});
	}

	return Promise.resolve(MANAGER_IDS);
}

export async function calculate(request: MutualFundRequest): Promise<any> {
	const { tab } = request;
	let url: string;
	switch (tab) {
		case "MUTUAL_FUND_SEARCH":
			url = Config.getApiUrl(
				`/api/public/mutual-fund/api-for-bankmonitor-hu/v4/mutual-funds/search-by-name-or-isin/${encodeURIComponent(
					request.text,
				)}`,
			);
			break;
		case "MUTUAL_FUND_COMPLEX":
			if (!request.managerIds || request.managerIds.length === 0) {
				return getManagerIds().then((managerIds) => {
					url = Config.getApiUrl(
						`/api/public/mutual-fund/api-for-bankmonitor-hu/v4/mutual-funds/search-by-curreny-and-type-and-category-and-manager/${encodeURIComponent(
							request.currencyCodes,
						)}/${encodeURIComponent(request.typeIds)}/${encodeURIComponent(
							request.categoryIds,
						)}/${encodeURIComponent(managerIds.map((mi) => mi.value).join(","))}`,
					);

					return http.get(url, request).catch(catchCalculatorError);
				});
			}
			url = Config.getApiUrl(
				`/api/public/mutual-fund/api-for-bankmonitor-hu/v4/mutual-funds/search-by-curreny-and-type-and-category-and-manager/${encodeURIComponent(
					request.currencyCodes,
				)}/${encodeURIComponent(request.typeIds)}/${encodeURIComponent(request.categoryIds)}/${encodeURIComponent(
					request.managerIds.map((mi) => mi.value || mi).join(","),
				)}`,
			);
			break;
		default:
			url = Config.getApiUrl(
				`/api/public/mutual-fund/api-for-bankmonitor-hu/v4/mutual-funds/search-by-curreny-and-risk-level/${encodeURIComponent(
					request.currencyCodes,
				)}/${encodeURIComponent(request.riskLevels)}`,
			);
			break;
	}

	return http.get(url).catch(catchCalculatorError);
}

export function searchParamsToRequest(
	searchParams: MutualFundSearchParams,
	sort: MutualFundSort = "name",
): MutualFundRequest {
	const requestBase = {
		sort,
		roleCode: "BM",
		comparator: sort,
		sortDir: 1,
		tab: searchParams.tab || "MUTUAL_FUND_SIMPLE",
	};

	if (requestBase.tab === "MUTUAL_FUND_SIMPLE") {
		return {
			...requestBase,
			currencyCodes: searchParams.singleCurrencyCode,
			riskLevels: searchParams.riskLevels,
		};
	}

	if (requestBase.tab === "MUTUAL_FUND_COMPLEX") {
		return {
			...requestBase,
			currencyCodes: searchParams.currencyCodes.join(","),
			categoryIds: [...(searchParams.categoryIdsBlock || [])].filter((id) => id !== "mixed").join(","),
			typeIds: searchParams.typeIds.join(","),
			managerIds: searchParams.managerIds,
		};
	}

	if (requestBase.tab === "MUTUAL_FUND_SEARCH") {
		return {
			...requestBase,
			text: searchParams.text,
		};
	}
}

export async function exportXls(searchParams: MutualFundSearchParams): Promise<string> {
	const request: MutualFundRequest = searchParamsToRequest(searchParams);

	return http.post(Config.getApiUrl("/api/private/mutual-fund/export"), request);
}

export function sortResultsBy(
	items: MutualFundResponseItem[],
	sort: string,
	sortDir: "asc" | "desc" = "desc",
): MutualFundResponseItem[] {
	const sortedList = items.sort((a, b) => (a[sort] > b[sort] ? 1 : -1));

	return sortDir === "asc" ? sortedList : sortedList.reverse();
}
